import request from "@utils/request";
// actionType
const SearchApiService = {
    /**
     * 查询
     * @param api 查询接口
     * @param pageSize 展示行数
     * @param name (当时搜索字段名) searchField | idField
     * @param value (当时搜索字段值)

     * @param callback
     * @returns {Function}
     */
    fetch(sApi, pageSize, name, value, pageIndex=1) {
        let data = {};
        const pagingQuery = {
            pageIndex: pageIndex,
            pageSize: pageSize ,
        }
        data['pagingQuery'] = pagingQuery;
        if(name)data[name] = value;
        return request({
            url:  sApi,
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
